import { AuthProvider } from 'react-admin';
import Keycloak, { KeycloakTokenParsed } from 'keycloak-js';
import jwt_decode, { jwtDecode } from 'jwt-decode';
import { storeReturnUrl } from '../return-url.utils';

export type PermissionsFunction = (decoded: KeycloakTokenParsed) => any;

export const keycloakAuthProvider = (
    client: Keycloak,
    options: {
        onPermissions?: PermissionsFunction;
        loginRedirectUri?: string;
        logoutRedirectUri?: string;
    } = {}
): AuthProvider => ({
    async login() {
        return client.login({
            redirectUri: options.loginRedirectUri ?? window.location.origin,
        });
    },
    async logout() {
        // Store current URL before logout for deep linking on next login
        storeReturnUrl();
        
        return client.logout({
            redirectUri: options.logoutRedirectUri ?? window.location.origin,
        });
    },
    async checkError() {
        return Promise.resolve();
    },
    async checkAuth() {
        return client.authenticated && client.token
            ? Promise.resolve()
            : Promise.reject('Failed to obtain access token.');
    },
    async getPermissions() {
        if (!client.token) {
            return Promise.resolve(false);
        }
        const decoded = jwtDecode<KeycloakTokenParsed>(client.token);
        return Promise.resolve(
            options.onPermissions ? options.onPermissions(decoded) : decoded
        );
    },
    async getIdentity() {

        if (client.token) {
            const decoded = jwtDecode<KeycloakTokenParsed>(client.token);
            console.log('getIdentity', decoded);

            const id = decoded.sub || '';
            const fullName = decoded.preferred_username;
            return Promise.resolve({ id, fullName });
        }
        return Promise.reject('Failed to get identity.');
    },
});